// components/skeletons/SkeletonProgramSection.js
export default function SkeletonProgramSection() {
  return (
    <section className="program_section bg-pattern">
      <div className="container">
        <div className="program-section-card animated-border">
          <div className="section_title section_title-white">
            <div className="flex items-center space-x-3 mb-4">
              {/* Icon Placeholder */}
              <div className="w-8 h-8 bg-gray-300 rounded animate-pulse"></div>
              {/* Title Placeholder */}
              <div className="h-6 bg-gray-300 rounded w-48 animate-pulse"></div>
            </div>
            {/* Subtitle Placeholder */}
            <div className="h-4 bg-gray-300 rounded w-64 animate-pulse mb-6"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-6 section-content-wrap">
            {/* Skeleton cards for programs */}
            {[1, 2, 3].map((item) => (
              <div
                key={item}
                className="program-item cursor-wait"
                aria-busy="true"
                aria-label="Loading program"
              >
                <div className="item-card">
                  <div className="program-icon">
                    <div className="w-16 h-16 bg-gray-300 rounded-full animate-pulse"></div>
                  </div>
                  <div className="item-content space-y-2 mt-3">
                    <div className="h-5 bg-gray-300 rounded w-32 animate-pulse"></div>
                    <div className="h-4 bg-gray-300 rounded w-48 animate-pulse"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
